/* ==================================================
  c_bargain-restriction.js — JST 日付ヘルパー（共有）
  - 商品詳細の在庫確認（c_sq-store-inventory）の閉店日判定で使う。
  - 購入制限（Web限定。バーゲン開始日を含む）の判定は c_web-limited.js に移した。
  - ビルド工程なしの素の IIFE。window.CBargainRestriction にぶら下げる（import/export しない）。
  - 日付判定は toLocaleDateString('en-CA',{timeZone:'Asia/Tokyo'}) の単一機構に統一（JST 絶対時計）。
===================================================*/
(function () {
  'use strict';

  /* 値（Date or 文字列）から JST の年月日 parts を返す。無効値 → null。 */
  function getJSTDateParts(value) {
    if (!value) return null;
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return null;
    const parts = d.toLocaleDateString('en-CA', { timeZone: 'Asia/Tokyo' }).split('-').map(Number);
    if (parts.length < 3 || parts.some(isNaN)) return null;
    return { year: parts[0], month: parts[1], day: parts[2] };
  }

  /* parts → ローカル midnight の Date（date-only 比較用）。 */
  function makeDateOnly(parts) {
    return new Date(parts.year, parts.month - 1, parts.day, 0, 0, 0, 0);
  }

  /* 現在の JST 日付（date-only）。 */
  function getTodayJSTDateOnly() {
    return makeDateOnly(getJSTDateParts(new Date()));
  }

  window.CBargainRestriction = {
    getJSTDateParts: getJSTDateParts,
    makeDateOnly: makeDateOnly,
    getTodayJSTDateOnly: getTodayJSTDateOnly
  };
})();
